import { defineMessages } from 'react-intl';

const messages = defineMessages({
  open: { id: 'gofre.Document.Dropdown.open' },
  close: { id: 'gofre.Document.Dropdown.close' },
});

export default messages;
